import React, { useEffect, useState } from "react";
import Classes from "../Settings.module.css";
import AddressAutocomplete from "./AddressAutocomplete";
import { useSelector, useDispatch } from "react-redux";
import backend from "../../../../../../api";
import { setUserData } from "../../../../../../redux-store/auth/actions";

export default function InfoTab() {
  const { user } = useSelector((s) => s.auth);
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    email: user?.email || "",
    phone: user?.phone || "",
    address: user?.customerProfile?.location?.address || "",
    city: user?.customerProfile?.location?.city || "",
    state: user?.customerProfile?.location?.state || "",
    postalCode: user?.customerProfile?.location?.postalCode || "",
    // country: user?.customerProfile?.location?.country || "",
    lat: user?.customerProfile?.location?.lat || "",
    lng: user?.customerProfile?.location?.lng || "",
    placeId: user?.customerProfile?.location?.placeId || "",
    neighborhood: user?.customerProfile?.location?.neighborhood || "",
    company: user?.customerProfile?.location?.company || "",
    gateCode: user?.customerProfile?.location?.gateCode || "",
    parkingSpot: user?.customerProfile?.location?.parkingSpot || "",
    notes: user?.customerProfile?.location?.notes || "",
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };


  const handleAddressChange = (text) => setForm((prev) => ({ ...prev, address: text }));

  const handleAddressSelect = (result) => {
    setForm((prev) => ({
      ...prev,
      address: result.formatted || prev.address,
      city: result.components?.city || "",
      state: result.components?.state || "",
      postalCode: result.components?.postalCode || "",
      // country: result.components?.country || "",
      lat: result.lat ?? "",
      lng: result.lng ?? "",
      placeId: result.placeId ?? "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      email: form.email, // allow email update if needed
      phone: form.phone,
      firstName: form.firstName,
      lastName: form.lastName,
      customerProfile: {
        ...(user.customerProfile || {}),
        location: {
          ...(user.customerProfile?.location || {}),
          address: form.address,
          city: form.city,
          state: form.state,
          postalCode: form.postalCode,
          // country: form.country,
          lat: form.lat,
          lng: form.lng,
          placeId: form.placeId,
          neighborhood: form.neighborhood,
          company: form.company,
          gateCode: form.gateCode,
          parkingSpot: form.parkingSpot,
          notes: form.notes,
        },
      },
    };

    const { data } = await backend.put(`/api/user/${user._id}`, payload);
    await dispatch(setUserData({ ...user, ...data.data }));
    alert("Profile saved");
  };


  useEffect(() => {
    setForm({
   firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    email: user?.email || "",
    phone: user?.phone || "",
    address: user?.customerProfile?.location?.address || "",
    city: user?.customerProfile?.location?.city || "",
    state: user?.customerProfile?.location?.state || "",
    postalCode: user?.customerProfile?.location?.postalCode || "",
    // country: user?.customerProfile?.location?.country || "",
    lat: user?.customerProfile?.location?.lat || "",
    lng: user?.customerProfile?.location?.lng || "",
    placeId: user?.customerProfile?.location?.placeId || "",
    neighborhood: user?.customerProfile?.location?.neighborhood || "",
    company: user?.customerProfile?.location?.company || "",
    gateCode: user?.customerProfile?.location?.gateCode || "",
    parkingSpot: user?.customerProfile?.location?.parkingSpot || "",
    notes: user?.customerProfile?.location?.notes || "",
    });
  }, [user]);

  return (
    <form className={Classes.form} onSubmit={handleSubmit}>
      <div className={Classes.flexColGroup}>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>First Name</h5>
          <input type="text" className={Classes.inputField} name="firstName" value={form.firstName} onChange={onChange} placeholder="John" required />
        </div>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>Last Name</h5>
          <input type="text" className={Classes.inputField} name="lastName" value={form.lastName} onChange={onChange} placeholder="Smith" required />
        </div>
      </div>

      <div className={Classes.flexColGroup}>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>Email Address</h5>
          <input type="email" className={Classes.inputField} name="email" value={form.email} onChange={onChange} placeholder="Johnsmith@email.com" required />
        </div>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>Phone Number</h5>
          <input type="text" className={Classes.inputField} name="phone" value={form.phone} onChange={onChange} placeholder="(111) 111-1111" />
        </div>
      </div>

      <div className={Classes.flexColGroup}>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>Address</h5>
          <AddressAutocomplete value={form.address} onChange={handleAddressChange} onSelect={handleAddressSelect} country={"usa"} />

          <div className={Classes.addrMetaRow}>
            <input className={Classes.inputField} placeholder="City" name="city" value={form.city} onChange={onChange} />
            <input className={Classes.inputField} placeholder="State/Province" name="state" value={form.state} onChange={onChange} />
          </div>
          <div className={Classes.addrMetaRow}>
            <input className={Classes.inputField} placeholder="Postal Code" name="postalCode" value={form.postalCode} onChange={onChange} />
            {/* <input className={Classes.inputField} placeholder="Country" name="country" value={form.country} onChange={onChange} /> */}
          </div>
        </div>
      </div>



      <div className={Classes.actions}>
        <button type="submit" className={Classes.saveBtn}><h5>Save</h5></button>
      </div>
    </form>
  );
}